import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Al inicio del archivo, antes del return
const savedTheme = localStorage.getItem('winal_theme');
if (savedTheme === 'light') document.body.classList.add('light');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);